
const BackImageModel = require("@/appModel/BackImage/BackImageModel")
const InspectPlaceModel = require("@/appModel/InspectPlace/InspectPlaceModel")
const InspectResultModel = require("@/appModel/InspectResult/InspectResultModel")
const InspectMasterModel = require("@/appModel/InspectMaster/InspectMasterModel")
const SortUtil = require("@/appUtils/SortUtil")

class InspectPlaceViewModel {
  constructor(tenantId, projectId, node, placeId = null) {
    this.tenantId = tenantId
    this.projectId = projectId
    this.node = node
    this.placeId = placeId
    this.inspectMasterList = []
    this.inspectPlace = null
  }

  async init(addPlaceData = null) {

    this.addPlaceData = addPlaceData
    // 検査マスタを取得
    
    await this.getRelatedInspectMaster()
    
    await this.getInspectPlace()
    
    await this.getInspectResult()
    
    this.setDefaultIcon()
    
    console.log(`マスタ件数 ${this.inspectMasterList.length}`)
    
  }
  setDefaultIcon() {
    // 新規の場合はアイコンリストの初期選択をセットする
    if (this.addPlaceData) {
      let master = this.activeInspectMaster()
      try {
        const defaultIcon = master.inspectMaster.iconSetting.filter(function(icon){
          return icon.isDefault
        }.bind(this))[0]
        this.inspectPlace.inspectPlace.iconId = defaultIcon.id
      } catch (e) {
        console.log(JSON.stringify(e))
      }
    }
  }
  async getInspectPlace() {
    if (this.placeId) {
      
      const sk = InspectPlaceModel.createSk(this.projectId, this.node, this.placeId)
      this.inspectPlace = await InspectPlaceModel.getInspectPlace({sk: sk})
      if (this.inspectPlace._deleted == true) {
        this.inspectPlace = null
        throw new Error("NOINSPECTPLACE")
        
      }
        
    } else {
      console.log(`add :${JSON.stringify(this.addPlaceData)}`)
      // 図面で追加した検査箇所情報を引き継ぎ
      this.inspectPlace = Object.assign({}, this.addPlaceData)
    }
  }
  async getInspectResult() {
    // 検査結果読み込み
    this.inspectResult = await InspectResultModel.getInspectResultList(this.projectId, this.node, this.placeId, this.tenantId)
  }
  async deleteInspectPlace() {
    try {
      // 検査結果削除
      for (let i = 0;i < this.inspectResult.length;i++){
        await InspectResultModel.deleteInspectResult(this.inspectResult[i])
      }
      // 検査箇所削除
      await InspectPlaceModel.deleteInspectPlace(this.inspectPlace)
      return true
    } catch (e) {
      console.log(`削除失敗 deleteInspectPlace ${JSON.stringify(e)}`)
      throw e
    }
  }
  /**
   * 検査箇所に紐づく検査マスタ
   */
  activeInspectMaster() {
    try {
      if (!this.inspectPlace.inspectPlace.inspectMasterId) {
        this.inspectPlace.inspectPlace.inspectMasterId = this.inspectMasterList[0].inspectMaster.id
        return this.inspectMasterList[0]
      }
      return this.inspectMasterList.filter(function(item) {
        return item.inspectMaster.id == this.inspectPlace.inspectPlace.inspectMasterId
      }.bind(this))[0]
    } catch (e) {
      console.log(`有効な検査マスタなし`)
      throw new Error(`NOACTIVEMASTER`)
    }
  }
  /**
   * アイコンクラスから検査アイコンのパスを取得
   */
  async getCurrentIconKey() {
    try {
      let selectedIcon = await this.activeInspectMaster().inspectMaster.iconSetting.filter(function(icon) {
        return icon.id == this.inspectPlace.inspectPlace.iconClass
      }.bind(this))
      if (selectedIcon.length > 0) {
        // S3キーを返す（バイナリデータはStorage.getで取得する）
        return selectedIcon.iconFilePath
      }
    } catch (e) {
      console.log(e)
      throw e
    }
  }
  /**
   * 関連する検査マスタを取得
   */
  async getRelatedInspectMaster() {

    const sk = BackImageModel.createSk(this.projectId, this.node)
    const backImageData = await BackImageModel.getBackImage({sk: sk}, this.tenantId)
    this.inspectMasterList = []
    for (let i = 0; i < backImageData.backImage.inspectMasterList.length;i++) {
      const inspectMasterId = backImageData.backImage.inspectMasterList[i]
      try {
        let master = await InspectMasterModel.getInspectMaster(InspectMasterModel.createSk(inspectMasterId), this.tenantId)
        if (!master._deleted) {
          this.inspectMasterList.push(master)
        }
        
      } catch (e) {
        // マスタが取得できない場合
        console.log(e.stack)
      }
    }

    if (this.inspectMasterList.length == 0) {
      throw new Error(`NOMASTERLIST`)
    }
    this.inspectMasterList = await SortUtil.sort(this.inspectMasterList, "inspectMaster.name", "ascending", true);
  }
  /**
   * 検査マスタのロックフラグを更新する
   */
  async updateInspectMasterFlg() {
    let targetMaster = this.activeInspectMaster()
    // ロックフラグをtrueに
    targetMaster.inspectMaster.lockFlg = true
    // 更新
    try {
      await InspectMasterModel.updateInspectMaster(targetMaster)
    } catch (e) {
      // この例外はハンドリングしない
      console.log(JSON.stringify(e))
    }
  }

}

module.exports = InspectPlaceViewModel;